import { render, staticRenderFns } from "./DashboardSalesHints.vue?vue&type=template&id=136055ce&lang=true"
import script from "./DashboardSalesHints.vue?vue&type=script&lang=js"
export * from "./DashboardSalesHints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports